import { render, staticRenderFns } from "./HotelPriceCell.vue?vue&type=template&id=d2b540aa&scoped=true"
import script from "./HotelPriceCell.vue?vue&type=script&lang=js"
export * from "./HotelPriceCell.vue?vue&type=script&lang=js"
import style0 from "./HotelPriceCell.vue?vue&type=style&index=0&id=d2b540aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b540aa",
  null
  
)

export default component.exports